<template>
  <div class="flex flex_justify_center flex_align_center my-3">
    <div>
      <DateTime v-model="startDate" :date="startDate" />
    </div>
    <div class="mx-5">{{ '<' }} {{ label }} {{ '<' }}</div>
    <div>
      <DateTime v-model="endDate" :date="endDate" />
    </div>
    <div>
      <button class="filter button is-danger mx-3" @click="onSubmitClick">Submit</button>
    </div>
  </div>
</template>

<script>
  import DateTime from '@/components/DateTime'

  export default {
    name: 'FilterDateRange',
    components: {
      DateTime
    },
    props: {
      filter: {
        type: String
      },
      label: {
        type: String
      },
      onSubmit: {
        type: Function,
        default: () => {}
      }
    },
    data() {
      return {
        startDate: null,
        endDate: null
      }
    },
    methods: {
      onSubmitClick() {
        const dateString = 'DD/MM/YYYY'
        let start
        let end
        if (this.startDate) {
          start = this.$moment(this.startDate).format(dateString)
        }
        if (this.endDate) {
          end = this.$moment(this.endDate).format(dateString)
        }
        this.onSubmit(this.filter, start, end)
      }
    }
  }
</script>
